export default {
      id: "filter-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite.1789552432127.svg#filter-usage",
      toString: function () {
        return this.url;
      }
    }